<!-- // 電話ログインは廃止。Firebase有料化にともない.2024.9 -->
<template l>
  <div class="login-container">
    <div class="login-content loading-container">
      <h1>でんわ番号でログイン</h1>
       <div class="error" v-if="ErrorMsg!==''">
         <!-- <i class="far fa-dizzy"></i> -->
         <i class="fas fa-info-circle"></i>
          {{ErrorMsg}}
        </div>

      <!-- ・C:ローディング -->
      <t-loading class="loading-item" :isLoading="IsLoading"></t-loading>

      <div >
        <!-- ・C:電話番号 -->
        <t-input
          v-model="ruleForm.phone"
          v-validate="'required|phoneNumber'"
          name="phone"
          ref="phone"
          :enterToEditEnd="false"
          v-bind:class="{disable:IsLoading}"
          :maxlength="24"
          class="input-container-cell"
          placeholder="けいたいでんわ番号をいれてね"
          inputType="text"
          label="けいたいでんわ番号"
          iconClassName="fas fa-mobile-alt"
          :isShowErrorMessage="errors.has('phone')"
          :errorMessage="errors.first('phone')"
          radius="30px"
        ></t-input>

       

        <!-- ・C:ログインボタン -->
        <button
          id="btn-login-phone"
          @click="LoginWithPhone()"
          v-bind:class="{disable:IsLoading || errors.has('phone')}"
          class="button-edit"
        >
          <i class="far fa-play-circle"></i>
          かくにんコードをSMSにおくる
          <div class="eigi">Send Kakunin Code</div>
        </button>


         <!-- やめるボタン -->
         <div class="button-back" @click="GoLoginHome" >
             <i class="fas fa-chevron-left"></i>
            やめる
        </div>

      </div>
    </div>
    
    <!-- ===========================
      ツール：ダイアログ
      ===========================-->
 <t-dialog :show="showModal" @ok="ModalCallback('ok')" @cancel="ModalCallback('cancel')">
    <template slot="header" >
        <div class="dialog-title">
           <i class="far fa-arrow-alt-circle-down"></i>
     
       <ruby>
          <rb>送</rb>
          <rt>おく</rt>
        </ruby>られてきた「 <ruby>
          <rb>確認</rb>
          <rt>かくにん</rt>
        </ruby>コード」をいれてね！
       </div>
</template>
  <template slot="body" >
     <div style="max-width:800px;" >
        <!-- かくにんコード -->
        <t-input
          v-model="ruleForm.verificationCode"
          v-validate="'required|max:6'"
          name="verificationCode"
          :enterToEditEnd="false"
          v-bind:class="{disable:IsLoading}"
          ref="code"
          :maxlength="10"
          class="input-container-cell"
          placeholder="かくにんコードをいれてね"
          inputType="text"
          label="・かくにんコード"
          iconClassName="fas fa-comment-alt"
          :isShowErrorMessage="errors.has('verificationCode')"
          :errorMessage="errors.first('verificationCode')"
          radius="30px"
        ></t-input>
        <!-- ログインボタン -->
        <button
          @click="ConfirmVerificationCode()"
          v-bind:class="{disable:IsLoading || errors.has('verificationCode')}"
          class="button-edit"
        >
          <i class="far fa-check-circle"></i>
          ログインする
          <div class="eigi">Login</div>
        </button>
      </div>
  </template>
  <template slot="footer" >
      <div class="footer-container">
<div class="button-cancel" @click="CloseModal()">
    <i class="far fa-times-circle"></i>
        やめる
        </div>
      </div>
        
      </template>
 </t-dialog>



  </div>
</template>

<script>
//--------------------------------
//検証メッセージのカスタマイズ処理
//--------------------------------
import { Validator } from "vee-validate";
import TDialog from "./TDialog";
const dict = {
  custom: {
    phone: {
      required: "けいたいでんわ番号をいれてね！",
      phoneNumber: "",
      max: "※ 11文字以内でいれてね"
    },
    verificationCode: {
      required: "かくにんコードをいれてね!",
      max: "※ 6文字以内でいれてね!"
    }
  }
};
Validator.localize("ja", dict);

//--------------------------------
//検証用：カスタム:電話番号
//--------------------------------
const telephone = {
  getMessage(field, args) {
    return "ただしいでんわ番号をいれてね！";
  },
  validate(value, args) {
    let pattern;
    if (value.indexOf("-") === -1) {
      // ハイフン無し
      pattern = /^\d{10}$|^\d{11}$/;
    } else {
      // ハイフンあり
      pattern = /^\d{2,5}-\d{1,4}-\d{4}$/;
    }
    return pattern.test(value);
  }
};

import TInput from "./TInput";
import Tloading from "./TLoading";
export default {
  name: "LoginPhone",
  components: { TInput, TDialog, "t-loading": Tloading },
  data() {
    return {
      ruleForm: {
        phone: "",
        verificationCode: ""
      },
      ErrorMsg: "", //仕様：空文字以外で表示される
      recaptchaVerifier: null,
      confirmationResult: null,
      IsLoading: false,
      showModal: false
    };
  },
  mounted() {
    Validator.extend("phoneNumber", telephone); //カスタムValidateを適用;※なぜこの場所：コンポーネントの外側で定義したら、エラーがでたため。この場所にやるとエラーがでなかったので。
    this.$refs.phone.ToFocus();
    var me = this;
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "btn-login-phone",
      {
        size: "invisible",
        callback: function(response) {
          console.log("-ok: reCAPTCHA solved, allow signInWithPhoneNumber.");
        },
        "expired-callback": function() {
          console.log(
            "-ng:expired-callback: Response expired. Ask user to solve reCAPTCHA again."
          );
          this.ErrorMsg = "error:reCAPTCHAエラー:expired-callback";
        },
        "error-callback": function() {
          console.log("-ng; error-callback");
          this.ErrorMsg = "error:reCAPTCHAエラー:error-callback";
        }
      }
    );
  },
  computed: {
    IsLogin() {
      if (null == this.$store.getters.loginUser) {
        return false;
      }
      return true;
    }
  },
  methods: {
    //================================
    //遷移：ログインページ
    //================================
    GoLoginHome() {
      //ページ遷移
      this.$router.push({ name: "login-home" });
    },
    //================================
    //ボタンクリック時：かくにんコードでログイン
    //================================
    ConfirmVerificationCode() {
      //値の検証
      this.$validator.validate("verificationCode").then(result => {
        //NG
        if (false === result) {
          return;
        }

        //OK
        this.ConfirmVerificationCodeProcess();
      });
    },
    //================================
    //処理：確認コードを使ってユーザーをログインさせる
    //================================
    ConfirmVerificationCodeProcess() {
      this.showModal = false;
      this.IsLoading = true;
      var code = this.ruleForm.verificationCode;
      this.confirmationResult
        .confirm(code)
        .then(
          function(result) {
            // User signed in successfully.
            this.IsLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            // User couldn't sign in (bad verification code?)
            // ...
            this.showModal = true;
            this.IsLoading = false;
            alert(error);
          }.bind(this)
        );
    }, //================================

    //ボタンクリック時：かくにんコードをおくる
    //================================
    LoginWithPhone() {
      //値の検証
      this.$validator.validate("phone").then(result => {
        //NG
        if (false === result) {
          return;
        }

        //OK
        this.ErrorMsg = "";
        this.LoginWithPhoneProcess();
      });
    },
    //================================
    //フォーカス：確認コード
    //================================
    ToFocusCode() {
      this.$nextTick(() => this.$refs.code.ToFocus());
    },
    //================================
    //処理：電話番号にSMS送信し、OKなら確認コード入力画面を表示
    //================================
    LoginWithPhoneProcess() {
      //電話番号についてるハイフンは事前に除去する
      var phoneNumber = "+81" + this.ruleForm.phone.replace(/-/g, ""); //日本の番号は+81を付与する
      this.IsLoading = true;
      firebase
        .auth()
        .signInWithPhoneNumber(phoneNumber, this.recaptchaVerifier)
        .then(
          function(confirmationResult) {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            this.confirmationResult = confirmationResult;
            console.log("-OK:LoginWithPhoneProcess:");

            // 確認コードを入力させるUIを表示
            this.showModal = true;
            this.ToFocusCode();
            this.IsLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.IsLoading = false;
            this.ErrorMsg = "error:" + error;
            console.log("-ng:LoginWithPhoneProcess: error." + error);
          }.bind(this)
        );
    },
    //================================
    //閉じる：確認コード入力ダイアログ
    //================================
    CloseModal() {
      this.ruleForm.verificationCode = ""; //リセット：確認コード
      this.showModal = false;
    }
  }
};
</script>


<style scoped lang="scss">
.login-container {
  display: flex;

  justify-content: center;
  align-items: center;
}

.login-content {
  border-radius: 10px;
  padding: 40px;
  padding-top: 10px;
}

h1,
h2 {
  font-weight: normal;
}
h1 {
  /* //縁取り文字 */
  font-weight: 600;
  color: yellow;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #666;

  & > ruby > rt {
    color: #666;
    font-size: 12px;
    -webkit-text-stroke-width: 0px;
  }
}

.error {
  color: rgb(250, 95, 48);
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  top: 77px;
  left: 48px;

  & > i {
    font-size: 18px;
    margin-right: 5px;
  }
}

//---------------
// ボタンスタイル：リセット
//---------------
button {
  border: none;
  outline: none;
}

//---------------
// もどるボタン
//---------------
.button-back {
  color: #42b983;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  text-decoration: none;
  margin-top: 20px;
  margin-left: 5px;
  & > i {
    margin-right: 5px;
  }
  &:hover {
    color: coral;
  }
}

//---------------
// コンテナ：ローディング
//---------------
.loading-container {
  position: relative;
  .loading-item {
    position: absolute;
    bottom: 50%;
    left: 40px;
    z-index: 999;
    transform: scale(1);
  }
}

//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

//--------------
//ボタン:基本
//--------------
.button-edit {
  cursor: pointer;
  color: #fff;
  width: 100%;
  margin-top: 30px;
  display: block;
  //border: 1px solid #42b983;
  background: #42b983;
  text-align: center;
  border-radius: 28px;
  padding-top: 15px;
  padding-bottom: 5px;
  padding-left: 20px;
  padding-right: 20px;
  vertical-align: middle;
  letter-spacing: 32x;
  font-weight: 600;
  font-size: 16px;
  transition: all 200ms 0s ease;
  box-shadow: 0px 3px #228659;

  & > .eigi {
    font-size: 14px;
    font-weight: normal;
    margin-bottom: 4px;
  }

  &:hover {
    background: #228659;
    box-shadow: 0px 3px #228659;
  }

  & > i {
    margin-right: 5px;
    font-size: 16px;
    font-weight: normal;
  }
}

//---------------
// ダイアログ：フッターコンテナー
//---------------
.footer-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}

//---------------
// ボタン：キャンセル
//---------------
.button-cancel {
  margin-top: 0px;
  display: inline-block;
  color: cadetblue;
  cursor: pointer;

  & > i {
    margin-right: 5px;
  }

  &:hover {
    color: coral;
  }
}

//---------------
// ダイアログ：タイトル
//---------------
.dialog-title {
  font-size: 18px;
  color: #42b983;

  & > i {
    margin-right: 5px;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPhone.vue